import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/index.vue'
import businessSettled from '../pages/businnssSettled.vue'
import policySupport from '../pages/policySupport.vue'
import park from '../pages/park.vue'
import parkState from '../pages/parkState.vue'
import contact from '../pages/contact.vue'
import policyInfo from '../pages/policyInfo.vue'
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
       {
           path:'/businessSettled',
           name:'businessSettled',
           component:businessSettled

       },
       {
        path:'/policySupport',
        name:'policySupport',
        component:policySupport

    },
    {
        path:'/park',
        name:'park',
        component:park

    },
    {
        path:'/parkState',
        name:'parkState',
        component:parkState

    },
    {
        path:'/contact',
        name:'contact',
        component:contact

    },
    {
        path:'/policyInfo',
        name:'policyInfo',
        component:policyInfo

    },

    ]
})
